import { render, staticRenderFns } from "./ShopTemplate.vue?vue&type=template&id=bcdcb74a&"
import script from "./ShopTemplate.vue?vue&type=script&lang=js&"
export * from "./ShopTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports